/* global dataLayer Turbolinks */

export { trackPageView }

function load() {
  (function(w,d,s,l,i) {
    w[l] = w[l] || []
    w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'})
    var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),
      dl=l!='dataLayer'?'&l='+l:''
    j.async=true
    j.src='//www.googletagmanager.com/gtm.js?id='+i+dl
    f.parentNode.insertBefore(j,f)
  })(window, document, 'script', 'dataLayer', window.googleTagManagerId)

  if ((typeof Turbolinks !== 'undefined') && Turbolinks.supported) {
    document.addEventListener('turbolinks:load', function(){
      trackPageView(window.location.href)
    }, true)
  } else {
    trackPageView(window.location.href)
  }
}

function trackPageView(url) {
  if (!window.googleTagManagerId) { return }
  dataLayer.push({
    'event': 'pageView',
    'virtualUrl': url
  })
}

if (window.googleTagManagerId) {
  load()
}
